module.exports = "images/ico-x.svg";